import * as React from 'react';

import ActResultReferenceContainer from '../../containers/ActResultReference';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 実績参照画面
 * @param props
 */
const ActResultReference: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('ActResultReference_0022')} />
			<ActResultReferenceContainer {...props} />
		</>
	);
};

export default ActResultReference;



// WEBPACK FOOTER //
// ./src/pages/personal/ActResultReference.tsx